module.exports = __webpack_public_path__ + "modules/platform/img/ry1.png";